var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CorralesListTabs',{attrs:{"start_date":_vm.start_date,"end_date":_vm.end_date}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }